import resourceIcon from "@mui/icons-material/SwapHoriz";
import { Button } from "@mui/material";
import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  DateField,
  Edit,
  List,
  SimpleForm,
  TextField,
  TextInput,
  useNotify,
  useRefresh,
} from "react-admin";
import {
  CardListActions,
  DefaultBulkActionButtons,
  EditorToolbar,
  MorePagination,
} from "../../components";
import { authClient } from "../../server";

function CreateView(props) {
  return (
    <Create {...props} redirect="edit">
      <SimpleForm toolbar={<EditorToolbar />}>
        <TextInput source="lecture_id" label="Lecture ID" />
        {/* <TextField source="total_amount" label="Amount" /> */}
        <TextInput source="payment_status" label="Payment Status" />
        <TextInput source="first_name" label="First Name" />
        <TextInput source="last_name" label="Last Name" />
        <TextInput source="email" label="Email" />
        <TextInput source="phone" label="Phone" />
        <TextInput source="address_line_1" label="Address Line 1" />
        <TextInput source="address_line_2" label="Address Line 2" />
        <TextInput source="city" label="City" />
        <TextInput source="state" label="state" />
        <TextInput source="zip" label="zip" />
        <TextInput source="country" label="country" />
        <TextInput source="dedication_text" label="Dedication Text" />
        <BooleanInput source="is_approved" label="Approved?" />
      </SimpleForm>
    </Create>
  );
}

function SendThankYouButton({ data }) {
  const refreshView = useRefresh();
  const notify = useNotify();
  console.log(data);
  //this won't work (facepalm)
  return data && !data.sent_thank_you_email ? (
    <Button
      onClick={() =>
        authClient
          .post(`admin/lecture-sponsors/send-thank-you-email`, { ...data })
          .then(() => {
            notify("Thank you email sent.");
            refreshView();
          })
      }
    >
      Send Thank You Email
    </Button>
  ) : (
    ""
  );
}

function EditView(props) {
  const { showNotif, refreshview, ...rest } = props;
  console.log(props);
  return (
    <div>
      <Edit
        {...rest}
        undoable={false}
        actions={
          <SendThankYouButton showNotif={showNotif} refreshview={refreshview} />
        }
      >
        <SimpleForm redirect={false} toolbar={<EditorToolbar showDelete />}>
          <TextInput source="lecture_id" label="Lecture ID" />
          {/* <TextField source="total_amount" label="Amount" /> */}
          <TextInput source="payment_status" label="Payment Status" />
          <TextInput source="first_name" label="First Name" />
          <TextInput source="last_name" label="Last Name" />
          <TextInput source="email" label="Email" />
          <TextInput source="phone" label="Phone" />
          <TextInput source="address_line_1" label="Address Line 1" />
          <TextInput source="address_line_2" label="Address Line 2" />
          <TextInput source="city" label="City" />
          <TextInput source="state" label="state" />
          <TextInput source="zip" label="zip" />
          <TextInput source="country" label="country" />
          <TextInput source="dedication_text" label="Dedication Text" />
          <BooleanInput source="is_approved" label="Approved?" />
        </SimpleForm>
      </Edit>
    </div>
  );
}

function ListView(props) {
  return (
    <List
      {...props}
      actions={<CardListActions exporter={true} />}
      filters={[]}
      perPage={50}
      pagination={<MorePagination />}
      sort={{
        field: "created_at",
        order: "DESC",
      }}
      title="Lecture Sponsors"
      bulkActionButtons={<DefaultBulkActionButtons />}
    >
      <Datagrid
        rowClick="edit"
        bulkActionButtons={<DefaultBulkActionButtons />}
      >
        <TextField source="id" />
        <TextField source="lecture_id" label="Lecture ID" />
        <BooleanField source="is_approved" label="Approved" />
        {/* <TextField source="total_amount" label="Amount" /> */}
        <TextField source="payment_status" label="Payment Status" />
        <TextField source="lecture.speaker_name" label="Speaker" />
        <TextField source="lecture.duration_str" label="Duration" />
        <TextField source="lecture.categories[0].name" label="Category" />
        <TextField source="lecture.subcategories[0].name" label="SubCategory" />
        <TextField source="first_name" label="First Name" />
        <TextField source="last_name" label="Last Name" />
        <TextField source="email" label="Email" />
        <TextField source="phone" label="Phone" />
        <TextField source="city" label="City" />
        <DateField
          source="created_at"
          label="Created At"
          showTime
          options={{
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            timeZone: "America/New_York",
          }}
        />
      </Datagrid>
    </List>
  );
}

export const LectureSponsors = {
  category: "database",
  name: "manage-lecture-sponsors",
  list: ListView,
  create: CreateView,
  icon: resourceIcon,
  options: { label: "Lecture Sponsors" },
  edit: EditView,
};
